import { SsoUserCreateDto } from '@lucidlink/dto/web-service-api';
import { prepareSsoUserCrypto } from './prepare-user-crypto';
export const prepareSsoRegisterUserDto = async ({ domainSecret, }) => {
    const userCrypto = await prepareSsoUserCrypto(domainSecret);
    const ssoUserRequest = {
        userIdentity: {
            userCryptoKey: userCrypto.wrappedCryptoKeyB64,
            userCryptoKeySalt: userCrypto.salt,
        },
    };
    return SsoUserCreateDto.create(ssoUserRequest);
};
